import { OnRampPaymentResponse } from "@src/shared/api/generated"
import { TableExpandable } from "@src/shared/componemts/TableExpandable"
import { dateTimeFormat } from "@src/shared/date"

type Props = {
  isLoading: boolean
  payment: OnRampPaymentResponse
}

export const OnRampPaymentExpandable = ({ isLoading, payment }: Props) => {
  const {
    amount,
    callback_url,
    created_at,
    customer,
    error,
    external_id,
    fiat_amount,
    fiat_symbol,
    id,
    network,
    project_id,
    return_url,
    status,
    symbol,
  } = payment

  return (
    <TableExpandable
      isLoading={isLoading}
      list={[
        ["ID", id],
        ["Project ID", project_id],
        ["External ID", external_id],
        ["Status", status],
        ["Amount (Crypto)", amount && `${amount} ${symbol} (${network})`],
        ["Amount (Fiat)", fiat_amount && `${fiat_amount} ${fiat_symbol}`],
        [
          "Customer",
          customer &&
            `${customer.first_name} ${customer.last_name} (${customer.email})`,
        ],
        [
          "Callback URL",
          callback_url,
          callback_url ? { target: "_blank", to: callback_url } : undefined,
        ],
        [
          "Return URL",
          return_url,
          return_url ? { target: "_blank", to: return_url } : undefined,
        ],
        ["Error code", error?.code],
        ["Error message", error?.message],
        ["Created at", created_at && dateTimeFormat(created_at)],
      ]}
    />
  )
}
